module.exports = __webpack_public_path__ + "img/bank-03-shinhan.8fb9a2e0.svg";